<div *ngIf="profileData" class="mct-gap-16 mct-grid-gt-sm mct-cols-1-1-gt-sm">
  <div class="mct-flex mct-col mct-gap-5 mct-col-1-span-2-gt-sm mt-16" *ngIf="profileData.DisplayOrgName">
    <label>
      {{ profileData.RequireOrgName ? '*' : '' }}
      {{ profileData.OrgNameLabel ? profileData.OrgNameLabel : ('common.personal-information.organization-name' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayFirstName">
    <label>
      {{ profileData.RequireFirstName ? '*' : '' }}
      {{ profileData.FirstNameLabel ? profileData.FirstNameLabel : ('common.personal-information.first-name' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayLastName">
    <label>
      {{ profileData.RequireLastName ? '*' : '' }}
      {{ profileData.LastNameLabel ? profileData.LastNameLabel : ('common.personal-information.last-name' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayMiddleInitial">
    <label>
      {{ profileData.RequireMiddleInitial ? '*' : '' }}
      {{
        profileData.MiddleInitialLabel
          ? profileData.MiddleInitialLabel
          : ('common.personal-information.middle-initial' | translate | ucfirst)
      }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayPrefix">
    <label>
      {{ profileData.RequirePrefix ? '*' : '' }}
      {{ profileData.PrefixLabel ? profileData.PrefixLabel : ('common.personal-information.prefix' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplaySuffix">
    <label>
      {{ profileData.RequireSuffix ? '*' : '' }}
      {{ profileData.SuffixLabel ? profileData.SuffixLabel : ('common.personal-information.suffix' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayTitle">
    <label>
      {{ profileData.RequireTitle ? '*' : '' }}
      {{ profileData.TitleLabel ? profileData.TitleLabel : ('common.personal-information.title' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayAddress1">
    <label>
      {{ profileData.RequireAddress1 ? '*' : '' }}
      {{ profileData.Address1Label ? profileData.Address1Label : ('common.personal-information.address1' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayAddress2">
    <label>
      {{ profileData.RequireAddress2 ? '*' : '' }}
      {{ profileData.Address2Label ? profileData.Address2Label : ('common.personal-information.address2' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayCity">
    <label>
      {{ profileData.RequireCity ? '*' : '' }}
      {{ profileData.CityLabel ? profileData.CityLabel : ('common.personal-information.city' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayState">
    <label>
      {{ profileData.RequireState ? '*' : '' }}
      {{ profileData.StateLabel ? profileData.StateLabel : ('common.personal-information.state' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayZip">
    <label>
      {{ profileData.RequireZip ? '*' : '' }}
      {{ profileData.ZipLabel ? profileData.ZipLabel : ('common.personal-information.zip' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayZipExt">
    <label>
      {{ profileData.RequireZipExt ? '*' : '' }}
      {{ profileData.ZipExtLabel ? profileData.ZipExtLabel : ('common.personal-information.zipext' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayCounty">
    <label>
      {{ profileData.RequireCounty ? '*' : '' }}
      {{ profileData.CountyLabel ? profileData.CountyLabel : ('common.personal-information.county' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayCountry">
    <label>
      {{ profileData.RequireCountry ? '*' : '' }}
      {{ profileData.CountryLabel ? profileData.CountryLabel : ('common.personal-information.country' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayWorkPhone">
    <label>
      {{ profileData.RequireWorkPhone ? '*' : '' }}
      {{ profileData.WorkPhoneLabel ? profileData.WorkPhoneLabel : ('common.personal-information.work-phone' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayHomePhone">
    <label>
      {{ profileData.RequireHomePhone ? '*' : '' }}
      {{ profileData.HomePhoneLabel ? profileData.HomePhoneLabel : ('common.personal-information.home-phone' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayCellPhone">
    <label>
      {{ profileData.RequireCellPhone ? '*' : '' }}
      {{ profileData.CellPhoneLabel ? profileData.CellPhoneLabel : ('common.personal-information.cell-phone' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayExt">
    <label>
      {{ profileData.RequireExt ? '*' : '' }}
      {{ profileData.ExtLabel ? profileData.ExtLabel : ('common.personal-information.ext' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayFax">
    <label>
      {{ profileData.RequireFax ? '*' : '' }}
      {{ profileData.FaxLabel ? profileData.FaxLabel : ('common.personal-information.fax' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayEmail">
    <label>
      {{ profileData.RequireEmail ? '*' : '' }}
      {{ profileData.EmailLabel ? profileData.EmailLabel : ('common.personal-information.email' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayWebsite">
    <label>
      {{ profileData.RequireWebsite ? '*' : '' }}
      {{ profileData.WebsiteLabel ? profileData.WebsiteLabel : ('common.personal-information.website' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-row mct-justify-start mct-items-start mt-16" *ngIf="profileData.DisplayBillingContact">
    <label *ngIf="profileData.RequireBillingContact">*</label>
    <p-checkbox name="BillingContact" [binary]="true" inputId="billingContact"> </p-checkbox>
    <label for="billingContact">
      {{
        profileData.BillingContactLabel
          ? profileData.BillingContactLabel
          : ('common.personal-information.billing-contact' | translate | ucfirst)
      }}
    </label>
  </div>
  <div class="mct-flex mct-row mct-justify-start mct-items-start mt-16" *ngIf="profileData.DisplayReceivesCommunication">
    <label *ngIf="profileData.RequireReceivesCommunication">*</label>
    <p-checkbox name="ReceivesCommunication" [binary]="true" inputId="receivesCommunication"> </p-checkbox>
    <label for="receivesCommunication">
      {{
        profileData.ReceivesCommunicationLabel
          ? profileData.ReceivesCommunicationLabel
          : ('common.personal-information.receives-communication' | translate | ucfirst)
      }}
    </label>
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayFullTimeEmployees">
    <label>
      {{ profileData.RequireFullTimeEmployees ? '*' : '' }}
      {{
        profileData.FullTimeEmployeesLabel
          ? profileData.FullTimeEmployeesLabel
          : ('form-builder.legos.profile.full-time-employees' | translate | ucfirst)
      }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayUserName">
    <label>
      {{ profileData.RequireUserName ? '*' : '' }}
      {{ profileData.UserNameLabel ? profileData.UserNameLabel : ('form-builder.legos.profile.username' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mt-16" *ngIf="profileData.DisplayPassword">
    <label>
      {{ profileData.RequirePassword ? '*' : '' }}
      {{ profileData.PasswordLabel ? profileData.PasswordLabel : ('form-builder.legos.profile.password' | translate | ucfirst) }}
    </label>
    <input class="form-control" />
  </div>
  <div class="mct-flex mct-col mct-gap-5 mct-col-1-span-2-gt-sm mt-16" *ngIf="profileData.DisplayEmailOptIn">
    <wl-email-optin-lego-summary [emailOptInData]="profileData.EmailOptInMetaDataLego"></wl-email-optin-lego-summary>
  </div>
</div>
